export enum GreenScreenParams {
	Fov = 'fov',
	VerticalAngle = 'vertical_angle',
	VerticalShift = 'vertical_shift',
	HorizontalShift = 'horizontal_shift',
	DistanceShift = 'distance_shift',
	SuspensionHeight = 'suspension_height',
	BodyColor = 'body_color',
	HorizontalAngle = 'horizontal_angle',
	SteeringAngle = 'steering_angle',
}
